import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { MarkEmailReadOutlined, SendOutlined } from '@mui/icons-material';

export default function GuestInvitationButton({ guest, onClick }) {
  const received = Boolean(guest.invitation?.responded_at);
  return (
    <Tooltip title={received ? 'Response received. Manage invitation' : 'Send invitation'} arrow>
      <IconButton size="small" aria-label={received ? 'Response received' : 'Send invitation'} color={received ? 'success' : 'primary'} onClick={onClick}>
        {received ? <MarkEmailReadOutlined fontSize="small" /> : <SendOutlined fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
